import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {Languages} from '../../../partials/layout/header-menus/Languages'
import {useAuth} from '../../../../app/modules/auth'
import '../../../../_metronic/assets/sass/core/components/custom-style/_base.scss'

const itemClass = 'ms-5 ms-lg-3'
const userAvatarClass = 'symbol-35px symbol-md-40px'

const Navbar = () => {
  const {currentUser} = useAuth()
  const intl = useIntl()

  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <Languages />
      </div>
      {currentUser ? (
        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            className={clsx('cursor-pointer text-center symbol custom-btn btn-custom-font btn-custom-color rounded-pill', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          > {intl.formatMessage({id: 'MENU.ACCOUNT'})}
          </div>
          <HeaderUserMenu />
        </div>
      ) : (
        <div className={clsx('app-navbar-item', itemClass)}>
          <Link to='/auth'>
            <div className=''>
              <button
                className='custom-btn btn-custom-font btn-custom-color rounded-pill'
                style={{width: '250px; !important'}}
              >
                {intl.formatMessage({id: 'MENU.LOGIN_SIGNUP'})}
              </button>
            </div>
          </Link>
        </div>
      )}
    </div>
  )
}

export {Navbar}
